<template>
  <div id="app">
    <section v-if="currentStep == 0" class="section is-medium">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-10">
            <div class="content is-medium">
              <h2 class="has-text-centered">Choose an image</h2>
            </div>
          </div>
        </div>
        <div class="columns is-centered is-multiline is-mobile">
          <div :key="img" v-for="img in images" class="column is-4-tablet is-half-mobile">
            <div v-bind:class="{'box has-background-success' : isSelected(img)}">
              <img :src="img + '_preview.jpeg'" @click.prevent="selectImage(img)" />
            </div>
          </div>
        </div>
        <div class="columns is-centered">
          <div class="column is-10">
            <div class="content is-medium has-text-centered">
              <button
                class="button is-large is-primary"
                :disabled="selectedImage === null"
                @click.prevent="nextStep"
              >Next Step</button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section v-if="currentStep == 1" class="section is-medium">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-10">
            <div class="content is-medium">
              <h2 class="has-text-centered">Choose a quote</h2>
            </div>
          </div>
        </div>
        <div class="columns is-centered is-multiline">
          <div :key="quote" v-for="quote in quotes" class="column is-4">
            <div
              class="quoteSelection is-vertical-center box is-size-4	"
              v-bind:class="{'has-background-success' : isSelectedQuote(quote)}"
              @click.prevent="selectQuote(quote)"
            >{{quote}}</div>
          </div>
        </div>
        <div class="columns is-centered">
          <div class="column is-10">
            <div class="content is-medium has-text-centered">
              <button class="button is-large is-light" @click.prevent="prevStep">Go Back</button> &nbsp;
              <button
                class="button is-large is-primary"
                :disabled="selectedQuote === null"
                @click.prevent="nextStep"
              >Next Step</button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section v-if="currentStep == 2" class="section is-medium">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-10">
            <div class="content is-medium">
              <h2 class="has-text-centered">Add a message on the back</h2>
            </div>
          </div>
        </div>
        <div class="columns is-centered is-multiline is-mobile">
          <div class="column is-10">
            <textarea
              v-model="customMessage"
              class="textarea"
              placeholder="Your message... max 350 characters"
              maxlength="350"
            ></textarea>
          </div>
        </div>
        <div class="columns is-centered">
          <div class="column is-10">
            <div class="content is-medium has-text-centered">
              <button class="button is-large is-light" @click.prevent="prevStep">Go Back</button> &nbsp;
              <button class="button is-large is-primary" @click.prevent="nextStep">Next Step</button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section v-if="currentStep == 3" class="section is-medium">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-5">
            <div class="content is-medium">
              <h2 class="has-text-centered">Who's receiving the card?</h2>
            </div>
          </div>
        </div>
        <div class="columns is-centered">
          <div class="column is-6">
            <form class="form">
              <div class="field">
                <div class="control">
                  <input
                    placeholder="Name of recipient"
                    class="input"
                    type="text"
                    v-model="to_name"
                    v-bind:class="{'is-danger': to_name_error}"
                  />
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <input
                    placeholder="Address line 1, e.g. Street Name, Street Number, App."
                    class="input"
                    type="text"
                    v-model="to_address_line1"
                    v-bind:class="{'is-danger': to_address_line1_error}"
                  />
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <input
                    placeholder="Address line 2 (Optional)"
                    class="input"
                    type="text"
                    v-model="to_address_line2"
                  />
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input
                        placeholder="City"
                        class="input"
                        type="text"
                        v-model="to_address_city"
                        v-bind:class="{'is-danger': to_address_city_error}"
                      />
                    </div>
                  </div>
                  <div class="field">
                    <div class="control">
                      <input
                        placeholder="Zipcode"
                        class="input"
                        type="text"
                        v-model="to_address_zip"
                        v-bind:class="{'is-danger': to_address_zip_error}"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <div class="select is-fullwidth">
                    <select v-model="to_address_country">
                      <option
                        v-bind:key="c.countryShortCode"
                        v-for="c in countries"
                        v-bind:value="c.countryShortCode"
                      >{{ c.countryName }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="field">
                <label class="label">State</label>
                <div class="control">
                  <div
                    class="select is-fullwidth"
                    v-bind:class="{'is-danger': to_address_state_error}"
                  >
                    <select v-model="to_address_state">
                      <option
                        v-bind:key="r.shortCode"
                        v-for="r in regions"
                        v-bind:value="r.shortCode"
                      >{{ r.name }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="columns is-centered">
          <div class="column is-10">
            <div class="content is-medium has-text-centered">
              <button class="button is-large is-light" @click.prevent="prevStep">Go Back</button> &nbsp;
              <button
                class="button is-large is-primary"
                :disabled="selectedQuote === null"
                @click.prevent="checkRecipient"
              >Next Step</button>
              <p
                v-if="showSaveError"
                class="has-text-danger"
              >Sorry, something went wrong while saving your card. Please try later again or report to hello@mindfuldevmag.com . Thank you.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-if="currentStep == 4" class="section is-medium">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-10">
            <div class="content is-medium">
              <h2 class="has-text-centered">What's your name?</h2>
            </div>
          </div>
        </div>
        <div class="columns is-centered is-multiline is-mobile">
          <div class="column is-10">
            <input
              type="text"
              v-model="from_name"
              class="input"
              placeholder="Your name on the card"
              maxlength="20"
            />
          </div>
        </div>
        <div class="columns is-centered">
          <div class="column is-10">
            <div class="content is-medium has-text-centered">
              <button class="button is-large is-light" @click.prevent="prevStep">Go Back</button> &nbsp;
              <button
                class="button is-large is-primary"
                v-bind:class="{'is-loading': saveCardLoading}"
                :disabled="from_name === null"
                @click.prevent="showPreview"
              >Next Step</button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-if="currentStep == 5" class="section is-medium">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-10">
            <div class="content is-medium">
              <h2 class="has-text-centered">Preview of Your Postcard</h2>
            </div>
          </div>
        </div>
        <div class="columns is-centered">
          <div class="column is-8 has-text-centered">
            <div class="aspect-ratio">
              <iframe :src="cardFrontUrl" width="600" height="408"></iframe>
            </div>
            <div class="aspect-ratio">
              <iframe :src="cardBackUrl" width="600" height="408"></iframe>
            </div>
          </div>
        </div>
        <div class="columns is-centered is-multiline is-mobile">
          <div class="column is-10">
            <div class="content is-medium has-text-centered">
              <p>{{paymentMessage}}</p>
              <p>Payment is secured and processed by Stripe. You can pay using credit card or Google and Apple Pay.</p></div>
          </div>
        </div>
        <div class="columns is-centered">
          <div class="column is-10">
            <div class="content is-medium has-text-centered">
              <button class="button is-large is-light" @click.prevent="prevStep">Go Back</button>
 &nbsp;
              <stripe-checkout
                ref="checkoutRef"
                :pk="publishableKey"
                :items="items"
                :amount="amount"
                :clientReferenceId="postcardId"
                :successUrl="successUrl"
                :cancelUrl="cancelUrl"
              >
                <template slot="checkout-button">
                  <button
                    class="button is-large is-primary" target="_blank"
                    @click.prevent="pay"
                  >Pay & Send Card Now</button>
                </template>
              </stripe-checkout>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import HelloWorld from "./components/HelloWorld.vue";
import atomic from "atomicjs";
import { StripeCheckout } from "vue-stripe-checkout";

export default {
  name: "App",
  components: {
    StripeCheckout
  },

  data: function() {
    return {
      publishableKey: process.env.VUE_APP_PUBLISHABLE_KEY,
      successUrl: process.env.VUE_APP_SUCCESS_URL,
      cancelUrl: process.env.VUE_APP_CANCEL_URL,
      items: [],
      amount: 1.99,
      currentStep: 0,
      images: [
        "39vpfhj59ZQ",
        "6sRqQj0KTvA",
        "01_igFr7hd4",
        "Uq3gTiPlqRo",
"FO7bKvgETgQ",
"B8JFJWzAC9s",
        "TFyi0QOx08c",
        "X0OoHrPvgXE",
        "KMn4VEeEPR8"
      ],
      quotes: [
        "Nobody can bring you peace but yourself.",
        "Enjoy the little things, for one day you may look back and realize they were the big things.",
        "Believe you can and you are halfway there.",
        "Respond; don’t react. Listen; don’t talk. Think; don’t assume.",
        "Courage is not the absence of fear, but the triumph over it.",
        "This is a wonderful day. I have never seen this one before.",
        "The present moment is filled with joy and happiness. If you are attentive, you will see it.",
        "You carry so much love in your heart, don't forget to give some to yourself.",
        "Don’t believe everything you think. Thoughts are just that – thoughts."
      ],
      selectedImage: null,
      selectedQuote: null,
      customMessage: "",

      to_name: null,
      to_address_line1: null,
      to_address_line2: "",
      to_address_city: null,
      to_address_state: null,
      to_address_zip: null,
      to_address_country: "US",

      from_name: null,

      to_name_error: false,
      to_address_line1_error: false,
      to_address_city_error: false,
      to_address_zip_error: false,
      to_address_state_error: false,
      showSaveError: false,
      countries: [],
      postcardId: null,
      saveCardLoading: false,
      cardFrontUrl: null,
      cardBackUrl: null,

      paymentMessage: ""
    };
  },
  computed: {
    regions: function() {
      var country = this.getSelectedCountryObj();
      if (country !== null) {
        return country.regions;
      }
      return [];
    }
  },
  methods: {
    getSelectedCountryObj: function() {
      for (var i = 0; i < this.countries.length; i++) {
        if (this.countries[i].countryShortCode === this.to_address_country) {
          console.log(this.countries[i]);
          return this.countries[i];
        }
      }
      return null; // should not happen
    },
    isSelected: function(img) {
      if (this.selectedImage === img) {
        return true;
      }
      return false;
    },
    isSelectedQuote: function(quote) {
      if (this.selectedQuote === quote) {
        return true;
      }
      return false;
    },
    selectImage: function(img) {
      this.selectedImage = img;
    },
    selectQuote: function(q) {
      this.selectedQuote = q;
    },
    nextStep: function() {
      this.currentStep += 1;
      this.trackPageView("cards/step_" + this.currentStep)
    },
    prevStep: function() {
      this.currentStep -= 1;
      this.trackPageView("cards/step_" + this.currentStep)
    },
    checkRecipient: function() {
      var error = false;
      this.to_name_error = false;
      this.to_address_line1_error = false;
      this.to_address_zip_error = false;
      this.to_address_city_error = false;
      this.to_address_state_error = false;
      this.showSaveError = false;

      if (this.isBlank(this.to_name)) {
        this.to_name_error = true;
        error = true;
      }
      if (this.isBlank(this.to_address_line1)) {
        this.to_address_line1_error = true;
        error = true;
      }
      if (this.isBlank(this.to_address_zip)) {
        this.to_address_zip_error = true;
        error = true;
      }
      if (this.isBlank(this.to_address_city)) {
        this.to_address_city_error = true;
        error = true;
      }
      if (this.isBlank(this.to_address_state)) {
        this.to_address_state_error = true;
        error = true;
      }
      if (!error) {
        this.nextStep();
      }
    },

    showPreview: function() {
      this.saveCardLoading = true;
      var self = this;
      var method = "POST";
      var url = "/.netlify/functions/postcard-order";
      if (this.postcardId !== null) {
        method = "PUT";
        url += "/" + this.postcardId;
      }
      var countryObj = self.getSelectedCountryObj();
      atomic(url, {
        method: method,
        headers: {
          "Content-type": "application/json"
        },
        data: {
          image: this.selectedImage,
          quote: this.selectedQuote,
          message: this.customMessage,
          to_name: this.to_name,
          to_address_line1: this.to_address_line1,
          to_address_line2: this.to_address_line2,
          to_address_city: this.to_address_city,
          to_address_zip: this.to_address_zip,
          to_address_state: this.to_address_state,
          to_address_country: this.to_address_country,
          from_name: this.from_name
        }
      })
        .then(function(response) {
          self.postcardId = response.data.ref["@ref"].id;
          var addressLabel =
            self.to_name +
            "<br>" +
            self.to_address_line1 +
            "<br>" +
            self.to_address_line2 +
            "<br>" +
            self.to_address_city +
            ", " +
            self.to_address_state +
            " " + self.to_address_zip +
            "<br>" +
            countryObj.countryName;

          var message = self.customMessage + "<hr>From: " + self.from_name;
          self.cardFrontUrl = encodeURI(
            "preview/front-card.html?quote=" +
              self.selectedQuote +
              "&image=" +
              self.selectedImage
          );
          self.cardBackUrl = encodeURI(
            "preview/back-card.html?name=" +
              addressLabel +
              "&message=" +
              message
          );
          self.saveCardLoading = false;

          if (self.to_address_country === "US") {
            self.items.push({
              sku: process.env.VUE_APP_SKU_POSTCARD_US,
              quantity: 1
            });
            self.amount = 1.99;
            self.paymentMessage =
              "This card costs 1.99$ and is shipped to the US.";
          } else {
            self.items.push({
              sku: process.env.VUE_APP_SKU_POSTCARD_INT,
              quantity: 1
            });
            self.amount = 2.99;
            self.paymentMessage =
              "This card costs 2.99$ and is shipped internationally.";
          }

          self.paymentMessage += "Cards are shipped from the US; depending on the destination it may take up to 21 days."

          self.nextStep();
        })
        .catch(function(error) {
          self.saveCardLoading = false;
          self.showSaveError = true;
          console.log(error.status); // xhr.status
          console.log(error.statusText); // xhr.statusText
        });
    },
    pay: function() {
      this.$refs.checkoutRef.redirectToCheckout();
    },
    isBlank: function(str) {
      return !str || /^\s*$/.test(str);
    },
    trackPageView: function(action) {
      try {
        window._paq.push(["setCustomUrl", "/" + action]);
        window._paq.push(["setDocumentTitle", action]);
        window._paq.push(["trackPageView"]);
      } catch (err) {}
    }
  },

  created: function() {
    var self = this;
    atomic("country-region.json", {
      method: "GET"
    }).then(function(response) {
      self.countries = response.data;
    });
  }
};
</script>

<style>
.quoteSelection {
  height: 200px;
}
.is-vertical-center {
  display: flex;
  align-items: center;
}

@media (max-width: 700px) {
  .aspect-ratio {
    padding: 20px;
    margin-bottom: 10px;
    transform: scale(0.6);
  }

  /* Adjust the iframe so it's rendered in the outer-width and outer-height of it's parent */
  .aspect-ratio iframe {
    width: 600px;
    height: 408px;
    display: inline-block;
    margin-top: -100px;
    margin-left: calc(-5% - 110px);
    margin-bottom: -100px;
  }
}
</style>
